'use client';
import { useEffect, useRef, useState } from 'react';

export const ScrollBar = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    setScrollPosition(
      Math.min(window.scrollY, ref.current?.clientHeight ?? -1),
    );
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className="flex-none h-auto"
      style={{
        background:
          'linear-gradient(#082946, #082946) no-repeat center/2px 100%',
        width: '1px',
      }}
      ref={ref}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        style={{
          marginLeft: '-10px',
          transform: `translateY(${scrollPosition}px)`,
        }}
      >
        <circle cx="10" cy="10" r="10" fill="#FDCB49" />
      </svg>
    </div>
  );
};
